import { connect } from 'react-redux'
import { compose, renderNothing, branch } from 'recompose'
import withOnClickCloseLoans from 'src/composables/withOnClickCloseLoans'
import withToBuyingReport from 'src/composables/withToBuyingReport'
import { selectHoShouldSeeBuyerReportNav } from 'src/store/selectors/navigation'
import omitProps from 'src/composables/omitProps'

const BuyingReportContainer = compose(
  connect(state => ({
    show: selectHoShouldSeeBuyerReportNav(state)
  })),
  branch(({ show }) => !show, renderNothing),
  omitProps('show', 'dispatch'),
  withToBuyingReport,
  withOnClickCloseLoans
)

export default BuyingReportContainer
